"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  generateTestId: true,
  generateTestIdProps: true
};
Object.defineProperty(exports, "generateTestId", {
  enumerable: true,
  get: function () {
    return _generateTestId.default;
  }
});
Object.defineProperty(exports, "generateTestIdProps", {
  enumerable: true,
  get: function () {
    return _generateTestIdProps.default;
  }
});
var _generateTestId = _interopRequireDefault(require("./generateTestId"));
var _generateTestIdProps = _interopRequireDefault(require("./generateTestIdProps"));
var _isTestEnv = require("./isTestEnv");
Object.keys(_isTestEnv).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _isTestEnv[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isTestEnv[key];
    }
  });
});
